var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "201px",
    height: "201px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#ffffff",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.46,40.7V54.87a3.06,3.06,0,0,1-3.07,3.06H15.18a3.06,3.06,0,0,1-3.06-3.06V9.13a3.06,3.06,0,0,1,3.06-3.06H36.39a3.06,3.06,0,0,1,3.07,3.06V20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.79,
    y1: 10.34,
    x2: 26.88,
    y2: 10.34,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.27,
    y1: 53.47,
    x2: 27.31,
    y2: 53.47,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.66,
    y1: 10.34,
    x2: 30.78,
    y2: 10.34,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.12,
    y1: 49.36,
    x2: 39.46,
    y2: 49.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.12,
    y1: 14.75,
    x2: 39.46,
    y2: 14.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.88,20H49.74a2.14,2.14,0,0,1,2.14,2.14V38.56a2.14,2.14,0,0,1-2.14,2.14H24a2.14,2.14,0,0,1-2.14-2.14V23A3,3,0,0,1,24.88,20Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.88,
    y1: 24.43,
    x2: 51.88,
    y2: 24.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.88,
    y1: 28.26,
    x2: 51.88,
    y2: 28.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,32.67a2.37,2.37,0,0,0-1.43.49,2.33,2.33,0,1,0-1.42,4.18,2.27,2.27,0,0,0,1.42-.5,2.33,2.33,0,1,0,1.43-4.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile_icon.e59a13d28ca3dff784dab9fda2f5bb35.svg";
export { ForwardRef as ReactComponent };